import React from 'react';
// import {RoutePermittedRole} from '@crema/constants/AppEnums';
import {TbDeviceDesktopAnalytics} from 'react-icons/tb';
import {BiSolidCategoryAlt} from 'react-icons/bi';
import {FaCodepen} from 'react-icons/fa';

const routesConfig = [
  {
    id: 'user',
    title: 'Users',
    messageId: 'Home',
    type: 'item',
    // permittedRole: [RoutePermittedRole.Admin],
    icon: <TbDeviceDesktopAnalytics />,
    url: '/Home',
  },
  {
    id: 'manage',
    title: 'Manage',
    messageId: 'sidebar.manage',
    type: 'group',
    children: [
      {
        id: 'blog',
        title: 'Blog',
        messageId: 'Blogs',
        type: 'collapse',
        icon: 'rss_feed',
        children: [
          {
            id: 'create-blog',
            title: 'create-blog',
            messageId: 'Create',
            type: 'item',
            url: '/create-blog',
          },
          {
            id: 'list',
            title: 'listing',
            messageId: 'List',
            type: 'item',
            url: '/blog-listing',
          },
        ],
      },
      {
        id: 'portfolio',
        title: 'portfolio',
        messageId: 'Portfolio',
        type: 'collapse',
        icon: <FaCodepen />,
        children: [
          {
            id: 'create-portfolio',
            title: 'create-portfolio',
            messageId: 'Create',
            type: 'item',
            url: '/create-portfolio',
          },
          {
            id: 'portfolio-list',
            title: 'portfolio-list',
            messageId: 'List',
            type: 'item',
            url: '/portfolio-listing',
          },
        ],
      },
      // {
      //   id: 'categories',
      //   title: 'categories',
      //   messageId: 'Categories',
      //   type: 'item',
      //   url: '/categories',
      //   icon: <BiSolidCategoryAlt />,
      // },
    ],
  },
];
export default routesConfig;
